import { t } from 'i18next';
import { CertificateExtension } from './CertificateExtension';
import { CertificateValidity } from './CertificateValidity';
import { SignatureAlgorithm } from './SignatureAlgorithm';

export class CertificateValue {
  constructor(
    private readonly version: string | null,
    private readonly serialNumber: string,
    private readonly subject: string,
    private readonly issuer: string,
    private readonly validity: CertificateValidity,
    private readonly extensions: CertificateExtension[] | null,
    private readonly signatureAlgorithm: SignatureAlgorithm | null,
    private readonly signature: string | null
  ) {}

  getVersion() {
    return this.version;
  }

  getSerialNumber() {
    return this.serialNumber;
  }

  getSubject() {
    return this.subject;
  }

  getIssuer() {
    return this.issuer;
  }

  getValidity() {
    return this.validity;
  }

  getExtensions() {
    return this.extensions;
  }

  getSignatureAlgorithm() {
    return this.signatureAlgorithm;
  }

  getSignature() {
    return this.signature;
  }

  toLocalizedObject() {
    const notBefore = this.getValidity().getNotBefore();
    const notAfter = this.getValidity().getNotAfter();
    const signatureAlgorithm = this.getSignatureAlgorithm();
    return {
      [t('version')]: this.getVersion(),
      [t('serialNumber')]: this.getSerialNumber(),
      [t('subject')]: this.getSubject(),
      [t('issuer')]: this.getIssuer(),
      [t('validity')]: {
        [t('notBefore')]: notBefore?.format('YYYY-MM-DD HH:mm:ss') || t('notSet'),
        [t('notAfter')]: notAfter?.format('YYYY-MM-DD HH:mm:ss') || t('notSet'),
      },
      [t('extensions')]:
        this.getExtensions()?.map((e) => ({
          [t('name')]: e.getName(),
          [t('value')]: e.getValue(),
          [t('critical')]: e.getCritical(),
        })) || [],
      [t('signatureAlgorithm')]: {
        [t('digest')]: signatureAlgorithm?.getDigest() ?? '',
        [t('algorithm')]: signatureAlgorithm?.getAlgorithm() ?? '',
        [t('rsaPadding')]: signatureAlgorithm?.getRsaPadding() ?? '',
      },
      [t('signature')]: this.getSignature() ?? '',
    };
  }
}
